<template>
  <b-container fluid class="subscribers">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          All Subscribers
        </div>
      </b-col>
    </b-row>
    <b-row class="m-2" v-if="subscribers.length < 1">
      <b-col lg="12" md="12" sm="12" xs="12" class="box pb-3 pt-2">
        No subscribers.
      </b-col>
    </b-row>
    <b-row class="m-2" v-if="subscribers.length > 0">
      <b-col lg="12" md="12" sm="12" xs="12" class="box text-left pb-3 pt-2" v-for="(subscriber, index) in subscribers" :key="index" :class={even:index%2}>
        <div class="remove" v-on:click="unsubscribe(subscriber)">Unsubscribe</div> {{subscriber}}
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'EmailSubscriber',
  data () {
    return {
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    },
    findAllSubscribers (page) {
      this.$store.dispatch('findAllSubscribers', {
        data: {
          page: page
        },
        success: (res) => {
          console.log('success')
        },
        fail: (res) => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    unsubscribe (email) {
      this.$store.dispatch('unsubscribe', {
        data: {
          email: email
        }
        // ,
        // success: (res) => {
        //   this.toast('Email removed.', 'success', 'check')
        // },
        // fail: (res) => {
        //   this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        // }
      }).then(() => {
        this.isLoading = false
        this.toast('Email removed.', 'success', 'check')
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
  },
  created () {
    this.findAllSubscribers(0)
  },
  computed: {
    ...mapGetters([
      'subscribers'
    ])
  }
}
</script>

<style scoped>
.subscribers {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  border-bottom: 1px solid #BDBDBD;
}
.box img {
  width: 100%;
}
.actionBtn {
  float:right;
  margin-top: 5px;
  margin-left: 15px;
  color: #455A64;
}
.actionBtn:hover {
  cursor: pointer;
  color: #000;
  text-decoration: underline;
}
.addBtn {
  background-color: #FF8F00;
  padding: 5px 25px;
  text-transform: capitalize;
  margin-left: 50px;
  color: #FFF;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.addBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
.remove {
  background-color: #FF8F00;
  color: #FFF;
  padding: 5px 25px;
  margin-bottom: 10px;
  float: right;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.remove:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EmailSubscribers.vue